import type { PublicRoute } from "../../../routes/registry";
import EnquireFormPage from "../EnquireFormPage";

/**
 * Get a quote (Story #25445). Registering a module replaces the pre-registry "existing" /enquire entry,
 * so the restyled page renders full-bleed (its own PageHead + .gw-wrap) instead of inside LegacyFrame.
 * Title and description are unchanged from that entry (BR-WEB-004).
 */
const route: PublicRoute = {
  path: "/enquire",
  element: <EnquireFormPage />,
  title: "Get a free quote | Greatway Patios",
  description:
    "Tell us about your project and request a free measure and quote from Greatway Patios. It takes about two minutes, and there’s no account to create.",
};

export default route;
